// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
// import "@fortawesome/fontawesome-free/js/all"

import jquery from 'jquery'
window.$ = window.jQuery = jquery

import moment from 'moment'
import 'moment/locale/ru'
window.moment = moment
moment.locale('ru')

// Daterangepicker
import 'daterangepicker'

/**
 * Russian translation for bootstrap-datepicker
 * Victor Taranenko <darwin@snowdale.com>
 */
// ;(function($){
// 	$.fn.datepicker.dates['ru'] = {
// 		days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
// 		daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
// 		daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
// 		months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
// 		monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
// 		today: "Сегодня",
// 		clear: "Очистить",
// 		format: "dd.mm.yyyy",
// 		weekStart: 1,
//     monthsTitle: 'Месяцы'
// 	};
// }(jQuery));
